export enum UploadState {
  Started,
  NextFile,
  Progress,
  Finished
}



// WEBPACK FOOTER //
// ./src/app/services/upload/upload-state.ts